@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.containerSurface {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  background-color:  hevo-toolkit-variables.$surface-bg;
}
